import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import {
	createTopBar,
	checkLocalSavedData,
	displayTooltip,
	destroyTooltip,
	displayTooltip02,
	destroyTooltip02,
	displayIndicator,
	destroyIndicator,
	handleGameProgressUpdate,
	playUISound,
	displayTutorialHand
} from "../helpers/levelManager"
import { htmlOverlay, phaserOverlay } from "../helpers/planetBlocker"

export default class FieldGuide extends Phaser.Scene {
	constructor() {
		super({ key: "FieldGuide" })
	}

	init() {
		// Game dimensions and scaling
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		// Get scaling information
		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight
		this.templateY = scalingData.templateY

		// Pagination settings
		this.currentPage = 0
		this.itemsPerPage = 5 // Reduced to 3 items per page to match design
		this.displayedCreatures = []
		this.filteredCreatures = []
		this.groupedCreatures = {} // For alphabetical grouping
		this.totalPages = 1

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor

		this.opened = false

		this.savedUserData = checkLocalSavedData()
		this.savedLevel = this.savedUserData?.userLevel || 0
		this.savedOrnament = this.savedUserData?.customization?.ornament || 0
		this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
		this.currentPlanet = this.savedUserData?.currentPlanet || 1

		this.clickable = true
	}

	create() {
		this.soundManager = this.scene.get("GameUI").soundManager

		this.creatureData = this.cache.json.get("creatureData")
		const creatures = this.creatureData.creatures

		createTopBar(this)

		// Background with proper scaling
		this.fieldBackground = this.add
			.image(this.gameW / 2, this.gameH / 2, "tabletBG")
			.setScale(this.scaleFactor, this.scaleFactor * 1.08)

		this.appBar = this.add
			.image(
				this.gameW / 2,
				this.gameH / 2 - 125 * this.scaleFactor,
				"fieldGuideAppBar",
			)
			.setScale(this.scaleFactor)
			.setDepth(5)

		this.appBarText = this.add
			.text(this.appBar.x, this.appBar.y, "Field Guide", {
				fontFamily: "Gluten",
				fontSize: this.fontSize - 6 * this.scaleFactor,
				color: "#11044E",
				align: "left",
				fontWeight: "700",
				fontStyle: "bold",
				resolution: 2,
			})
			.setOrigin(0.5)
			.setDepth(5)

		this.backButton = this.add
			.image(
				this.appBar.x - 230 * this.scaleFactor,
				this.appBar.y,
				"appBackButton",
			)
			.setVisible(false)
			.setScale(this.scaleFactor * 0.5)
			.setDepth(5)
			.setTint("#000")

		this.backButton.setInteractive().on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			destroyTooltip(this)
			destroyIndicator(this)

			this.backButton.setVisible(false)

			// Destroy all story-related elements
			this.backstoryGroup.clear(true, true)

			// Show input field again
			this.inputField.style.display = "block"

			this.appBarText.setText("Field Guide")
			this.selectedCreatureText.setText("")
			// Re-enable interaction for displayed creatures
			this.displayedCreatures.forEach((item) => {
				if (Array.isArray(item)) {
					item.forEach((element) => element.setInteractive())
				} else {
					item.setInteractive()
				}
			})

			if(this.tutorialHand){
				this.tutorialHand.destroy()
			}

			this.opened = false
		})

		// this.headerText = this.add.text(
		//     this.firstArrow.x + 50 * this.scaleFactor,
		//     this.firstArrow.y,
		//     'A',
		//     {
		//         fontFamily: 'Gluten',
		//         fontSize: this.fontSize - 6 * this.scaleFactor,
		//         color: '#11044E',
		//         align: 'left',
		//         fontWeight: '700',
		//         fontStyle: 'bold',
		//         resolution: 2
		//     }
		// ).setOrigin(0.5).setDepth(5);

		// this.secondArrow = this.add.text(
		//     this.headerText.x + 50 * this.scaleFactor,
		//     this.headerText.y,
		//     '>',
		//     {
		//         fontFamily: 'Gluten',
		//         fontSize: this.fontSize - 6 * this.scaleFactor,
		//         color: '#3E27BE',
		//         align: 'left',
		//         fontWeight: '700',
		//         fontStyle: 'bold',
		//         resolution: 2
		//     }
		// ).setOrigin(0.5).setDepth(5);

		this.selectedCreatureText = this.add
			.text(this.appBarText.x + 90 * this.scaleFactor, this.appBarText.y, "", {
				fontFamily: "Gluten",
				fontSize: this.fontSize - 10 * this.scaleFactor,
				color: "#3E27BE",
				align: "left",
				fontWeight: "700",
				fontStyle: "bold",
				resolution: 2,
			})
			.setOrigin(0.5)
			.setDepth(5)

		this.closeButton = this.add
			.image(
				this.appBar.x + 230 * this.scaleFactor,
				this.appBar.y,
				"appCloseButton",
			)
			.setTint("#000")
			.setDepth(10)
			.setScale(this.scaleFactor * 0.5)

		this.closeButton.setInteractive().on("pointerdown", () => {
			// if (this.opened) {
			// 	// Destroy all story-related elements
			// 	this.backstoryGroup.clear(true, true)

			// 	// Show input field again
			// 	this.inputField.style.display = "block"

			// 	destroyIndicator(this)

			// 	this.appBarText.setText("Field Guide")
			// 	this.selectedCreatureText.setText("")
			// 	// Re-enable interaction for displayed creatures
			// 	this.displayedCreatures.forEach((item) => {
			// 		if (Array.isArray(item)) {
			// 			item.forEach((element) => element.setInteractive())
			// 		} else {
			// 			item.setInteractive()
			// 		}
			// 	})

			// 	this.opened = false
			// } else {
			// 	this.inputField.remove()
			// 	this.scene.stop("FieldGuide")
			// 	this.scene.resume("TabletScene")
			// }
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)

			this.inputField.remove()
			if (this.clearButton) this.clearButton.remove()
			this.scene.stop("FieldGuide")
			this.scene.resume("TabletScene")
		})

		// Input container with search icon
		this.searchContainer = this.add.container(
			this.gameW / 2,
			this.appBar.y + 60 * this.scaleFactor,
		)

		// Input background
		this.inputBackground = this.add
			.image(0, 0, "longContainer")
			.setScale(this.scaleFactor * 0.244)
			.setTint(0xffffff).setVisible(false)
		this.searchContainer.add(this.inputBackground)

		// this.clearSearchButton = this.add
		// 	.image(
		// 		this.inputBackground.x,
		// 		this.inputBackground.y,
		// 		"appCloseButton",
		// )
		// .setScale(this.scaleFactor * 0.5)

		// Search icon
		this.searchIcon = this.add
			.image(
				this.inputBackground.displayWidth / 2 - 20 * this.scaleFactor,
				0,
				"searchIcon", // Assuming you have this asset
			)
			.setScale(this.scaleFactor * 0.5).setVisible(false)
		this.searchContainer.add(this.searchIcon)

		this.createInputField()
		this.organizeCreaturesByAlphabet(creatures)
		this.createNavigationButtons()

		// Display creatures initially
		this.displayCreatures()
	}

	createInputField() {
		// Create input field
		this.inputField = document.createElement("input")
		this.inputField.type = "text"
		this.inputField.placeholder = "Enter creature name"
		this.inputField.style.position = "fixed"
		this.inputField.style.width = Math.round(480 * this.scaleFactor) + "px"
		this.inputField.style.height = Math.round(50 * this.scaleFactor) + "px"
		this.inputField.style.fontSize = Math.round(20 * this.scaleFactor) + "px"
		this.inputField.style.fontFamily = '"Space Grotesk", sans-serif'
		this.inputField.style.border = "1px solid #11044E"
		this.inputField.style.background = "white"
		this.inputField.style.color = "#11044E"
		this.inputField.style.borderRadius =
			Math.round(25 * this.scaleFactor) + "px"
		this.inputField.style.paddingLeft = Math.round(15 * this.scaleFactor) + "px"
		this.inputField.style.paddingRight =
			Math.round(40 * this.scaleFactor) + "px" // Space for clear button

		// Add to the HTML UI container instead of body
		const htmlContainer = document.getElementById("html-ui-container")
		htmlContainer.appendChild(this.inputField)

		// Create clear button
		this.clearButton = document.createElement("div")
		this.clearButton.innerHTML = "×" // Using × symbol instead of background image
		this.clearButton.style.position = "fixed" // Use fixed positioning like the input
		this.clearButton.style.width = Math.round(20 * this.scaleFactor) + "px"
		this.clearButton.style.height = Math.round(20 * this.scaleFactor) + "px"
		this.clearButton.style.fontSize = Math.round(30 * this.scaleFactor) + "px"
		this.clearButton.style.color = "#11044E"
		this.clearButton.style.cursor = "pointer"
		this.clearButton.style.display = "flex"
		this.clearButton.style.alignItems = "center"
		this.clearButton.style.justifyContent = "center"
		this.clearButton.style.fontWeight = "bold"
		this.clearButton.style.userSelect = "none"
		this.clearButton.style.zIndex = "1000"

		//debug
		//this.inputField.style.display = "none"

		// Add to the HTML UI container instead of body
		htmlContainer.appendChild(this.clearButton)

		// Position input field and clear button
		this.updateInputPosition()

		// Show/hide clear button based on input content
		this.inputField.addEventListener("input", () => {
			if (this.inputField.value.length > 0) {
				this.clearButton.style.display = "flex"
			} else {
				this.clearButton.style.display = "none"
			}

			// Your existing filter logic
			if (this.filterTimer) {
				this.filterTimer.remove()
			}
			this.filterTimer = this.time.delayedCall(
				300,
				this.filterCreatures,
				[],
				this,
			)

			if (this.overlayReference) {
				this.overlayReference.remove()

				this.clickable = true
			}
		})

		// Add click event to clear the input field
		this.clearButton.addEventListener("click", () => {
			this.inputField.value = ""
			this.clearButton.style.display = "none"
			// Trigger input event to update filters
			this.inputField.dispatchEvent(new Event("input"))
		})

		// Handle touch events to blur input field
		document.addEventListener("touchstart", (event) => {
			if (
				!this.inputField.contains(event.target) &&
				!this.clearButton.contains(event.target)
			) {
				this.inputField.blur()
			}
		})
	}

	updateInputPosition() {
		const canvas = this.game.canvas
		const rect = canvas.getBoundingClientRect()

		// Position relative to the search container
		const x = this.gameW / 2
		const y = this.appBar.y + 20 * this.scaleFactor

		// Position input field relative to the Phaser canvas
		const inputLeft = rect.left + x - this.inputField.offsetWidth / 2
		const inputTop =
			rect.top + y - this.inputField.offsetHeight / 2 + 30 * this.scaleFactor

		this.inputField.style.left = `${inputLeft}px`
		this.inputField.style.top = `${inputTop}px`

		// Position clear button inside the input field (right side)
		if (this.clearButton) {
			const clearButtonRight =
				inputLeft +
				this.inputField.offsetWidth -
				Math.round(30 * this.scaleFactor)
			const clearButtonTop =
				inputTop +
				this.inputField.offsetHeight / 2 -
				this.clearButton.offsetHeight / 2

			this.clearButton.style.left = `${clearButtonRight}px`
			this.clearButton.style.top = `${clearButtonTop}px`
		}

		// Hide clear button initially
		this.clearButton.style.display = "none"
	}

	organizeCreaturesByAlphabet(creatures) {
		// Sort creatures alphabetically
		const sortedCreatures = [...creatures].sort((a, b) =>
			a.name.localeCompare(b.name),
		)

		// Group by first letter
		this.groupedCreatures = {}
		sortedCreatures.forEach((creature) => {
			const firstLetter = creature.name.charAt(0).toUpperCase()
			if (!this.groupedCreatures[firstLetter]) {
				this.groupedCreatures[firstLetter] = []
			}
			this.groupedCreatures[firstLetter].push(creature)
		})

		// Create a flat list of creatures with their groups for pagination
		this.flattenedCreatures = []
		for (const letter in this.groupedCreatures) {
			this.flattenedCreatures.push({ type: "header", letter })
			this.groupedCreatures[letter].forEach((creature) => {
				this.flattenedCreatures.push({ type: "creature", data: creature })
			})
		}

		this.filteredCreatures = [...this.flattenedCreatures]
		this.totalPages = Math.ceil(
			this.filteredCreatures.length / this.itemsPerPage,
		)
	}

	filterCreatures() {
		const searchText = this.inputField.value.toLowerCase()

		if (searchText === "") {
			// Show all creatures in alphabetical groups
			this.filteredCreatures = [...this.flattenedCreatures]
		} else {
			// Filter creatures that match the search
			const matchingCreatures = this.creatureData.creatures.filter((creature) =>
				creature.name.toLowerCase().includes(searchText),
			)

			// Create a filtered flattened list
			this.filteredCreatures = []

			// Group matching creatures by letter
			const groupedMatching = {}
			matchingCreatures.forEach((creature) => {
				const firstLetter = creature.name.charAt(0).toUpperCase()
				if (!groupedMatching[firstLetter]) {
					groupedMatching[firstLetter] = []
				}
				groupedMatching[firstLetter].push(creature)
			})

			// Create the filtered list with headers
			for (const letter in groupedMatching) {
				this.filteredCreatures.push({ type: "header", letter })
				groupedMatching[letter].forEach((creature) => {
					this.filteredCreatures.push({ type: "creature", data: creature })
				})
			}
		}

		// Reset to first page after filtering
		this.currentPage = 0
		this.totalPages = Math.ceil(
			this.filteredCreatures.length / this.itemsPerPage,
		)
		this.displayCreatures()
	}

	displayCreatures() {
		// Clear previous creature displays
		this.displayedCreatures.forEach((item) => {
			if (Array.isArray(item)) {
				item.forEach((element) => element.destroy())
			} else {
				item.destroy()
			}
		})
		this.displayedCreatures = []

		// Calculate start and end indices for current page
		const startIndex = this.currentPage * this.itemsPerPage
		const endIndex = Math.min(
			startIndex + this.itemsPerPage,
			this.filteredCreatures.length,
		)

		// Starting Y position for the list
		let currentY = this.fieldBackground.y - 40 * this.scaleFactor
		let headerTextString

		// Display creatures for current page
		for (let i = startIndex; i < endIndex; i++) {
			const item = this.filteredCreatures[i]

			if (item.type === "header") {
				// Add letter header
				const headerText = this.add.text(
					this.fieldBackground.x - 225 * this.scaleFactor,
					currentY,
					item.letter,
					{
						fontFamily: "Space Grotesk",
						fontSize: this.fontSize - 4 * this.scaleFactor,
						color: "#11044E",
						fontWeight: "700",
						fontStyle: "bold",
						resolution: 2,
					},
				)
				this.displayedCreatures.push(headerText)

				// Add divider line
				const line = this.add.graphics()
				line.lineStyle(2, 0x11044e, 0.8)
				line.beginPath()
				line.moveTo(
					this.fieldBackground.x - 225 * this.scaleFactor,
					currentY + 20 * this.scaleFactor,
				)
				line.lineTo(
					this.fieldBackground.x + 225 * this.scaleFactor,
					currentY + 20 * this.scaleFactor,
				)
				line.closePath()
				line.strokePath()
				this.displayedCreatures.push(line)

				// Move down for next item
				currentY += 30 * this.scaleFactor
			} else {
				// It's a creature entry
				const creature = item.data

				// Creature name
				const creatureNameText = this.add
					.text(
						this.fieldBackground.x - 225 * this.scaleFactor,
						currentY,
						creature.name,
						{
							fontFamily: "Space Grotesk",
							fontSize: this.fontSize - 6,
							color: "#11044E",
							align: "left",
							fontStyle: "bold",
							fontWeight: "700",
							resolution: 2,
						},
					)
					.setInteractive()

				// "More details" text
				const detailsText = this.add
					.text(
						this.fieldBackground.x + 140 * this.scaleFactor,
						currentY,
						"more details",
						{
							fontFamily: "Space Grotesk",
							fontSize: this.fontSize - 4 * this.scaleFactor,
							color: "#11044E",
							align: "right",
							resolution: 2,
						},
					)
					.setInteractive()

				const detailsLine = this.add.graphics()
				detailsLine.lineStyle(1, 0x11044e, 0.8)
				detailsLine.beginPath()
				detailsLine.moveTo(
					this.fieldBackground.x + 140 * this.scaleFactor,
					detailsText.y + 18 * this.scaleFactor,
				)
				detailsLine.lineTo(
					this.fieldBackground.x + 225 * this.scaleFactor,
					detailsText.y + 18 * this.scaleFactor,
				)
				detailsLine.closePath()
				detailsLine.strokePath()
				detailsLine.setAlpha(0.5)
				this.displayedCreatures.push(detailsLine)

				// Add a line under the text
				const line = this.add.graphics()
				line.lineStyle(1, 0x11044e, 0.8)
				line.beginPath()
				line.moveTo(
					this.fieldBackground.x - 225 * this.scaleFactor,
					currentY + 30 * this.scaleFactor,
				)
				line.lineTo(
					this.fieldBackground.x + 225 * this.scaleFactor,
					currentY + 30 * this.scaleFactor,
				)
				line.closePath()
				line.strokePath()
				line.setAlpha(0.5)
				this.displayedCreatures.push(line)

				// Handler for clicking on creature name or details
				const clickHandler = () => {
					if (!this.clickable) {
						return
					}
					playUISound(this, this.soundManager, "Subtle click 1", 0.25)
					headerTextString = creature.name.charAt(0).toUpperCase()
					this.appBarText.setText("Field Guide > " + headerTextString)
					this.selectedCreatureText.setText("       > " + creature.name)
					// Hide input and disable interactions
					this.inputField.style.display = "none"
					this.clearButton.style.display = "none"
					this.displayedCreatures.forEach((item) => {
						if (Array.isArray(item)) {
							item.forEach((element) => {
								if (element.disableInteractive) {
									element.disableInteractive()
								}
							})
						} else if (item.disableInteractive) {
							item.disableInteractive()
						}
					})

					//destroyTooltip(this)
					//destroyTooltip02(this)
					this.showBackStory(creature)
					this.opened = true
				}

				creatureNameText.on("pointerdown", clickHandler)
				detailsText.on("pointerdown", clickHandler)

				// Store as an array to make cleanup easier
				this.displayedCreatures.push([creatureNameText, detailsText])

				// Move down for next creature
				currentY += 35 * this.scaleFactor
			}
		}

		// Update navigation buttons
		this.updateNavigationButtons()
	}

	createNavigationButtons() {
		// Container for pagination
		this.paginationContainer = this.add.container(
			this.fieldBackground.x,
			this.fieldBackground.y + 145 * this.scaleFactor,
		)

		// Previous page button
		this.prevButton = this.add
			.image(-100 * this.scaleFactor, 0, "navLeftButton")
			.setScale(this.scaleFactor * 0.25)
			.setInteractive()
			.on("pointerdown", () => this.prevPage())
		this.paginationContainer.add(this.prevButton)

		// Create page number buttons (5 total)
		this.pageButtons = []
		for (let i = 1; i <= 5; i++) {
			//const button = this.add.container(-100 * this.scaleFactor + (i * 50 * this.scaleFactor), 0);
			const button = this.add.container(
				this.prevButton.x + i * 35 * this.scaleFactor,
				0,
			)
			// Background
			const bg = this.add
				.image(0, 0, i === 1 ? "navSelectedButton" : "navUnselectedButton")
				.setScale(this.scaleFactor * 0.25)

			// Page number
			const text = this.add
				.text(0, 0, i.toString(), {
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize - 4 * this.scaleFactor,
					color: i === 1 ? "#FFFFFF" : "#BECCFF",
					align: "center",
					resolution: 2,
				})
				.setOrigin(0.5)

			button.add([bg, text])
			button
				.setInteractive(
					new Phaser.Geom.Rectangle(
						-15 * this.scaleFactor,
						-15 * this.scaleFactor,
						30 * this.scaleFactor,
						30 * this.scaleFactor,
					),
					Phaser.Geom.Rectangle.Contains,
				)
				.on("pointerdown", () => this.goToPage(i - 1))

			this.pageButtons.push({ container: button, bg, text })
			this.paginationContainer.add(button)
		}

		// Next page button
		this.nextButton = this.add
			.image(
				this.pageButtons[this.pageButtons.length - 1].container.x +
				35 * this.scaleFactor,
				0,
				"navRightButton",
			)
			.setScale(this.scaleFactor * 0.25)
			.setInteractive()
			.on("pointerdown", () => this.nextPage())
		this.paginationContainer.add(this.nextButton)

		if (this.currentPlanet === 1) {
			if (this.savedMiniLevel === 2) {
				displayTooltip(this, {
					// xPos: this.inputBackground.x - 320 * this.scaleFactor,
					// yPos: this.inputBackground.y + 20 * this.scaleFactor,
					xPos: 100 * this.scaleFactor,
					//yPos: 125 * this.scaleFactor,
					yPos: this.appBar.y + 50 * this.scaleFactor,
					type: "mediumChunkyRightTip",
					scale: 1.2,
					text: "Type in the creature\nname [b](Froststalker)[/b]",
					fontScale: -8,
					xTextOffset: -7,
					yTextOffset: 3,
					wrapWidth: 1.1,
				})

				// displayTooltip02(this, {
				// 	xPos: this.nextButton.x + 550 * this.scaleFactor,
				// 	yPos: this.appBar.y + 275 * this.scaleFactor,
				// 	type: "pageThroughTip",
				// 	scale: 1,
				// 	text: "Or page through the\nfull directory of creatures.\nIt will be located under [b]'F'[/b]",
				// 	fontScale: -8,
				// 	xTextOffset: 4,
				// 	yTextOffset: 3,
				// 	wrapWidth: 1.41,
				// })

				const overlay = phaserOverlay(this)
				const maskWidth = this.gameW - 360 * this.scaleFactor;
				const maskHeight = this.gameH - 335 * this.scaleFactor;

				this.clickable = false
				overlay.setTargetByCoords(
					(this.gameW / 2) - (maskWidth / 2),
					this.appBar.y + 23 * this.scaleFactor,
					maskWidth,
					this.inputBackground.height * this.scaleFactor * 0.3,
					16
				);

				displayTutorialHand(this, {
					xPos: this.appBar.x - 280 * this.scaleFactor,
					yPos: this.appBar.y + 120 * this.scaleFactor,
					rotation: 45,
				})

				overlay.setAboveOverlay([this.tooltip, this.tooltipText, this.tutorialHand])

				this.overlayReference = overlay
			}
		}
	}

	prevPage() {
		if (!this.clickable) {
			return
		}
		//destroyTooltip(this)
		//destroyTooltip02(this)
		playUISound(this, this.soundManager, "Subtle click 1", 0.25)
		if (this.currentPage > 0) {
			this.currentPage--
			this.displayCreatures()
			this.updatePageButtons()
		}
	}

	nextPage() {
		if (!this.clickable) {
			return
		}
		//destroyTooltip(this)
		//destroyTooltip02(this)
		playUISound(this, this.soundManager, "Subtle click 1", 0.25)
		const maxPages =
			Math.ceil(this.filteredCreatures.length / this.itemsPerPage) - 1
		if (this.currentPage < maxPages) {
			this.currentPage++
			this.displayCreatures()
			this.updatePageButtons()
		}
	}

	goToPage(pageIndex) {
		if (!this.clickable) {
			return
		}
		//destroyTooltip(this)
		//destroyTooltip02(this)
		playUISound(this, this.soundManager, "Subtle click 1", 0.25)
		const maxPages =
			Math.ceil(this.filteredCreatures.length / this.itemsPerPage) - 1
		if (pageIndex >= 0 && pageIndex <= maxPages) {
			this.currentPage = pageIndex
			this.displayCreatures()
			this.updatePageButtons()
		}
	}

	updatePageButtons() {
		// Get the first page number to display (centered around current page)
		let firstPageToShow = Math.max(0, this.currentPage - 2)
		const maxPages = Math.ceil(
			this.filteredCreatures.length / this.itemsPerPage,
		)

		// Adjust if we're near the end
		if (firstPageToShow + 5 > maxPages) {
			firstPageToShow = Math.max(0, maxPages - 5)
		}

		// Update the page buttons
		this.pageButtons.forEach((button, index) => {
			const pageNum = firstPageToShow + index + 1
			const isCurrentPage = firstPageToShow + index === this.currentPage

			// Update page number
			button.text.setText(pageNum.toString())

			// Update style based on selection
			button.bg.setTexture(
				isCurrentPage ? "navSelectedButton" : "navUnselectedButton",
			)
			button.text.setColor(isCurrentPage ? "#FFFFFF" : "#11044E")

			// Show/hide based on if we have enough pages
			button.container.setVisible(pageNum <= maxPages)

			// Update click handler
			button.container.off("pointerdown")
			button.container.on("pointerdown", () =>
				this.goToPage(firstPageToShow + index),
			)
		})
	}

	updateNavigationButtons() {
		const maxPages =
			Math.ceil(this.filteredCreatures.length / this.itemsPerPage) - 1

		// Update page buttons
		this.updatePageButtons()

		// Disable/enable previous button
		this.prevButton
			.setAlpha(this.currentPage > 0 ? 1 : 0.3)
			.setInteractive(this.currentPage > 0)

		// Disable/enable next button
		this.nextButton
			.setAlpha(this.currentPage < maxPages ? 1 : 0.3)
			.setInteractive(this.currentPage < maxPages)
	}

	createFeedButton() {

		console.log("CREATE FEED BUTTON")

		let cockpitScene = this.scene.get("CockpitScene")

		this.feedBtn = this.add
			.image(
				this.gameW / 2 + 170 * this.scaleFactor,
				this.gameH / 2 + 125 * this.scaleFactor,
				"normalWideBtn",
			)
			.setScale(this.scaleFactor * 0.4).setInteractive()



		this.feedBtn.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			handleGameProgressUpdate(cockpitScene)
			this.scene.stop("FieldGuide")
			this.scene.stop("TabletScene")
			this.scene.stop("TabletUI")
			this.scene.resume("CockpitScene")
		})

		let feedText = this.add
			.text(this.feedBtn.x, this.feedBtn.y - 5 * this.scaleFactor, "FEED", {
				fontFamily: "Gluten",
				fontSize: this.fontSize + 3 * this.scaleFactor,
				color: "#FFFFFF",
				align: "center",
				fontStyle: "bold",
				resolution: 2,
			})
			.setOrigin(0.5)

		if (this.currentPlanet === 1 && this.savedMiniLevel === 8) {
			displayTutorialHand(this, {
				xPos: this.feedBtn.x + 100 * this.scaleFactor,
				yPos: this.feedBtn.y - 100 * this.scaleFactor,
				rotation: -135,
			})
		}

		if (this.currentPlanet === 1 && this.savedMiniLevel === 8) {
			//let tabletViewUI = this.scene.get("TabletUI")
			//tabletViewUI.closeButtonHandPointer()
		}
		this.backstoryGroup.add(this.feedBtn)
		this.backstoryGroup.add(feedText)
	}

	showBackStory(creature) {
		console.log(
			"Creature FieldGuide : " +
			creature.name +
			" minilevel: " +
			this.savedMiniLevel,
		)

		//createFeedButton()

		let cockpitScene = this.scene.get("CockpitScene")

		destroyTooltip(this)
		destroyTooltip02(this)



		// Create a group for backstory elements for easier cleanup
		this.backstoryGroup = this.add.group()

		this.backButton.setVisible(true)

		// Story background with proper scaling
		const storyBackground = this.add
			.image(this.gameW / 2, this.gameH / 2, "tabletBG")
			.setScale(this.scaleFactor, this.scaleFactor * 1.08)
		this.backstoryGroup.add(storyBackground)

		// Create text container with responsive positioning
		const textContainer = {
			x: storyBackground.x - 100 * this.scaleFactor,
			y: storyBackground.y,
		}

		// Creature name with scaled font size
		const creatureName = this.add.text(
			textContainer.x - 130 * this.scaleFactor,
			textContainer.y - 85 * this.scaleFactor,
			creature.name,
			{
				fontFamily: "Space Grotesk",
				fontSize: this.fontSize + 4 * this.scaleFactor,
				color: "#11044E",
				align: "left",
				fontStyle: "bold",
				resolution: 2,
			},
		)
		this.backstoryGroup.add(creatureName)

		// Scientific name with scaled font size
		const scientificName = this.add.text(
			textContainer.x - 130 * this.scaleFactor,
			textContainer.y - 55 * this.scaleFactor,
			creature.scientificName,
			{
				fontFamily: "Space Grotesk",
				fontStyle: "bold",
				fontSize: this.fontSize - 4 * this.scaleFactor,
				color: "#11044E",
				align: "left",
				resolution: 2,
			},
		)
		this.backstoryGroup.add(scientificName)

		// Backstory text with word wrapping and scaled font
		const backStoryText = this.add.text(
			textContainer.x - 130 * this.scaleFactor,
			textContainer.y - 20 * this.scaleFactor,
			creature.backStory,
			{
				fontFamily: "Space Grotesk",
				fontSize: this.fontSize - 7 * this.scaleFactor,
				color: "#11044E",
				align: "left",
				resolution: 2,
				wordWrap: { width: this.gameW * 0.35 },
			},
		)
		this.backstoryGroup.add(backStoryText)

		const container = this.add
			.image(
				textContainer.x + 270 * this.scaleFactor,
				textContainer.y + 30 * this.scaleFactor,
				"fieldGuideContainer",
			)
			.setScale(this.scaleFactor * 0.25)
		this.backstoryGroup.add(container)

		let creatureImageString
		if (creature.index < 10) {
			creatureImageString = "fgCreature0" + creature.index + "Thumb"
		} else {
			creatureImageString = "fgCreature" + creature.index + "Thumb"
		}
		// Creature image with scaled sizing
		const creatureImage = this.add
			.image(
				textContainer.x + 270 * this.scaleFactor,
				textContainer.y - 10 * this.scaleFactor,
				creatureImageString,
			)
			.setScale((this.scaleFactor * 0.85 * 0.25))
		this.backstoryGroup.add(creatureImage)

		const zoomInButton = this.add
			.image(
				creatureImage.x + 50 * this.scaleFactor,
				creatureImage.y + 50 * this.scaleFactor,
				"zoomBtn",
			)
			.setScale(this.scaleFactor * 0.25)
			.setInteractive()
			.on("pointerdown", () => {
				this.createFullScreenView(creature.index)
			})
		this.backstoryGroup.add(zoomInButton)
		// Stats label
		// const statsText = this.add.text(
		// 	creatureImage.x - 50 * this.scaleFactor,
		// 	creatureImage.y + 70 * this.scaleFactor,
		// 	"Stats:",
		// 	{
		// 		fontFamily: "Space Grotesk",
		// 		fontSize: this.fontSize - 6 * this.scaleFactor,
		// 		color: "#11044E",
		// 		align: "left",
		// 		fontWeight: "700",
		// 		fontStyle: "bold",
		// 		resolution: 2,
		// 	},
		// )
		// this.backstoryGroup.add(statsText)

		// Creature stats
		const stats = this.add.text(
			creatureImage.x - 50 * this.scaleFactor,
			creatureImage.y + 70 * this.scaleFactor,
			`Color: ${creature.color}\nVenomous: ${creature.venomous}`,
			{
				fontFamily: "Space Grotesk",
				fontSize: this.fontSize - 7 * this.scaleFactor,
				color: "#11044E",
				align: "left",
				resolution: 2,
				fontWeight: "400",
			},
		)
		this.backstoryGroup.add(stats)

		if (creature.food[0] === '["Other"]' || creature.food[0] === "Other") {
			return
		}

		if (creature.food && creature.food.length > 0) {
			let xOffset = 0 // To track horizontal position for multiple food items
			let creatureFoodIndex

			creatureFoodIndex = creature.foodID

			// Convert to array if it's a single string
			const foodArray = Array.isArray(creature.food)
				? creature.food
				: [creature.food]
			const foodIDArray = Array.isArray(creature.foodID)
				? creature.foodID
				: [creature.foodID]

			// Loop through each food item
			foodArray.forEach((foodItem, index) => {
				const foodName = foodItem.replace(/\s/g, "\n")
				const container = this.add
					.image(
						textContainer.x - 68 * this.scaleFactor + xOffset,
						textContainer.y + 130 * this.scaleFactor,
						"fieldGuideContainer",
					)
					.setScale((this.scaleFactor * 0.11), (this.scaleFactor * 0.15))
				this.backstoryGroup.add(container)

				container.angle = 90
				// Add food image
				const foodImage = this.add
					.image(
						textContainer.x - 100 * this.scaleFactor + xOffset,
						textContainer.y + 130 * this.scaleFactor,
						"food0" + foodIDArray[index] + "_thumb",
					)
					.setScale(this.scaleFactor * 1.2 * 0.25)
				this.backstoryGroup.add(foodImage)
				this.foodImageRef = foodImage

				// Add food text next to its image
				const foodText = this.add.text(
					foodImage.x + 30 * this.scaleFactor,
					foodImage.y - 10 * this.scaleFactor,
					foodName,
					{
						fontFamily: "Space Grotesk",
						fontSize: this.fontSize - 8 * this.scaleFactor,
						color: "#11044E",
						align: "left",
						resolution: 2,
					},
				)

				if (this.currentPlanet === 1 && this.savedMiniLevel === 2) {
					if (creature.name === "Froststalker") {
						console.log("Correct Creature Field Guide")

						// let tabletViewUI = this.scene.get("TabletUI")
						// tabletViewUI.displayTool()

						const overlay = phaserOverlay(this);

						// Define your cutouts
						const cutouts = [
							{
								x: this.gameW / 2 + 105 * this.scaleFactor,
								y: this.gameH / 2 + 95 * this.scaleFactor,
								width: 130 * this.scaleFactor,
								height: 50 * this.scaleFactor,
								radius: 12
							}
							,
							{
								x: 182 * this.scaleFactor,
								y: this.gameH / 2 + 91 * this.scaleFactor,
								width: 150 * this.scaleFactor,
								height: 80 * this.scaleFactor,
								radius: 12
							}
						];

						overlay.setMultipleCutouts(cutouts);

						displayTutorialHand(this, {
							xPos: this.gameW / 2 + 170 * this.scaleFactor + 53 * this.scaleFactor,
							yPos: this.gameH / 2 + 125 * this.scaleFactor + 45 * this.scaleFactor,
							rotation: -30
						})

						this.createFeedButton()

						displayTooltip(this, {
							xPos: this.foodImageRef.x + 25 * this.scaleFactor,
							yPos: this.foodImageRef.y - 50 * this.scaleFactor,
							type: "whatItEatsTip",
							scale: 1,
							text: "This is what it eats",
							fontScale: -8,
							xTextOffset: 1,
							yTextOffset: -6,
							wrapWidth: 0.8,
						})

						displayTooltip02(this, {
							xPos: this.feedBtn.x + 2 * this.scaleFactor,
							yPos: this.feedBtn.y - 50 * this.scaleFactor,
							type: "pressToFeedTip",
							scale: 1,
							text: "[b]Press ‘FEED’[/b]\nto feed it",
							fontScale: -8,
							xTextOffset: 1,
							yTextOffset: -6,
							wrapWidth: 0.8,
						})

						overlay.setAboveOverlay([this.tutorialHand, this.tooltip, this.tooltipText, this.tooltip02, this.tooltipText02])
						// displayIndicator(
						// 	this,
						// 	foodText.x + 15 * this.scaleFactor,
						// 	foodText.y - 4 * this.scaleFactor,
						// 	1.1,
						// 	"dietIndicator",
						// )
					}
				}

				this.backstoryGroup.add(foodText)

				// Increase horizontal offset for next food item
				xOffset += 180 * this.scaleFactor
			})
		}

		if (this.currentPlanet === 1) {
			if (this.savedMiniLevel === 1) {
				// return;
			}
			if (this.savedMiniLevel === 2) {
				if (creature.name === "Froststalker") {
					console.log("Correct Creature Field Guide")
					//handleGameProgressUpdate(cockpitScene)

				}
			}
			if (this.savedMiniLevel === 8) {
				console.log("Field Guide Opened Food Checked")
				if (creature.name === "Ice Crawler") {
					let tabletViewUI = this.scene.get("TabletUI")
					tabletViewUI.displayInd()
					this.createFeedButton()

					displayTutorialHand(this, {
						xPos: this.feedBtn.x + 50 * this.scaleFactor,
						yPos: this.feedBtn.y - 70 * this.scaleFactor,
						rotation: -145
					})
				}
			}
		}

		if (this.currentPlanet === 2) {
			if (this.savedMiniLevel === 2) {
				if (creature.name === "Driftback") {
					let tabletViewUI = this.scene.get("TabletUI")
					tabletViewUI.displayInd()
					this.createFeedButton()

					displayTutorialHand(this, {
						xPos: this.feedBtn.x + 50 * this.scaleFactor,
						yPos: this.feedBtn.y - 70 * this.scaleFactor,
						rotation: -145
					})
				}
			}
			if (this.savedMiniLevel === 8) {
				if (creature.name === "Cloudstrider") {
					this.createFeedButton()
					let tabletViewUI = this.scene.get("TabletUI")
					tabletViewUI.displayInd()

					displayTutorialHand(this, {
						xPos: this.feedBtn.x + 50 * this.scaleFactor,
						yPos: this.feedBtn.y - 70 * this.scaleFactor,
						rotation: -145
					})
				}
			}
			if (this.savedMiniLevel === 15) {
				if (creature.name === "Skyray") {
					this.createFeedButton()
				}
			}
		}

		if (this.currentPlanet === 3) {
			if (this.savedMiniLevel === 5) {
				if (creature.name === "Obsidian Snail") {
					this.createFeedButton()
				}
			}
			if (this.savedMiniLevel === 13) {
				if (creature.name === "Blazewraith") {
					this.createFeedButton()
				}
			}
			if (this.savedMiniLevel === 20) {
				if (creature.name === "Smoth") {
					this.createFeedButton()
				}
			}
		}
	}

	createFullScreenView(creatureIndex) {
		playUISound(this, this.soundManager, "Subtle click 1", 0.25)
		let creatureImageString
		if (creatureIndex < 10) {
			creatureImageString = `creature0${creatureIndex}_fed`
		} else {
			creatureImageString = `creature${creatureIndex}_fed`
		}
		const fullViewBackground = this.add
			.image(
				this.gameW / 2,
				this.appBar.y + 140 * this.scaleFactor,
				`wideContainer`,
			)
			.setScale(this.scaleFactor * 0.9, this.scaleFactor * 1.4)
			.setDepth(55)

		const maskBG = this.add
			.image(
				this.gameW / 2,
				this.appBar.y + 140 * this.scaleFactor,
				`wideContainer`,
			)
			.setScale(this.scaleFactor * 0.9, this.scaleFactor * 1.2)
			.setVisible(false)
			.setDepth(55)

		// Show full view
		const fullView = this.add
			.image(
				this.gameW / 2,
				this.gameH / 2 + 10 * this.scaleFactor,
				creatureImageString,
			)
			.setScale((this.scaleFactor) * 0.35)
			.setDepth(55)

		fullView.mask = new Phaser.Display.Masks.BitmapMask(this, maskBG)

		// Track current zoom level
		let currentZoom = (this.scaleFactor) * 0.35;
		const minZoom = (this.scaleFactor) * 0.25;
		const maxZoom = (this.scaleFactor * 2.0) * 0.25;
		const zoomStep = (this.scaleFactor * 0.1) * 0.25;

		const zoomInButton = this.add
			.image(
				fullView.x + 180 * this.scaleFactor,
				fullView.y + 50 * this.scaleFactor,
				"creatureScaleUpButton",
			)
			.setScale(this.scaleFactor * 0.55)
			.setInteractive()
			.setDepth(55)

		const zoomOutButton = this.add
			.image(
				fullView.x + 180 * this.scaleFactor,
				fullView.y + 90 * this.scaleFactor,
				"creatureScaleDownButton",
			)
			.setScale(this.scaleFactor * 0.55)
			.setInteractive()
			.setDepth(55)

		zoomInButton.on("pointerdown", () => {
			if (currentZoom < maxZoom) {
				currentZoom += zoomStep
				fullView.setScale(currentZoom)
				playUISound(this, this.soundManager, "Subtle click 1", 0.15)
			}
		})

		zoomOutButton.on("pointerdown", () => {
			if (currentZoom > minZoom) {
				currentZoom -= zoomStep
				fullView.setScale(currentZoom)
				playUISound(this, this.soundManager, "Subtle click 1", 0.15)
			}
		})

		// Add close button
		const closeButton = this.add
			.image(
				fullView.x + 180 * this.scaleFactor,
				fullView.y - 110 * this.scaleFactor,
				"closeButton",
			)
			.setScale(this.scaleFactor * 0.5)
			.setInteractive()
			.setDepth(55)

		// Add close handler
		closeButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			fullViewBackground.destroy()
			fullView.destroy()
			closeButton.destroy()
			zoomInButton.destroy()
			zoomOutButton.destroy()
			destroyTooltip(this)
		})
	}
}
